import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation SetUserIsTyping($id: ID!, $value: Boolean!) {
    setUserIsTyping(id: $id, value: $value) {
      id
      userIsTyping
    }
  }
`);
